import { MessageTemplate } from '@/features/messages/MessageTemplate';
import { defineStore } from 'pinia';
import { useBaseStore } from '../shared/baseStore';
import { container } from 'inversify-props';
import { IDriverMessagesService, IDriverMessagesServiceId } from '@/features/messages/IDriverMessagesService';
import { DriverMessage } from '@/features/messages/DriverMessage';
import { useTripsStore } from '../trips/tripsStore';

export const useMessagesStore = defineStore('messages', {
    state: () => ({
        templates: new Array<MessageTemplate>()
    }),
    actions: {
        async fetchTemplates() {
            const baseStore = useBaseStore();
            const tripsStore = useTripsStore();
            const driverMessagesService = container.get<IDriverMessagesService>(IDriverMessagesServiceId);

            try {
                baseStore.setIsLoading(true);

                this.templates = await driverMessagesService.getTemplates(tripsStore.transportType);
            } catch {
                this.templates = new Array<MessageTemplate>();
            } finally {
                baseStore.setIsLoading(false);
            }
        },
        async sendMessage(message: DriverMessage) {
            const baseStore = useBaseStore();
            const driverMessagesService = container.get<IDriverMessagesService>(IDriverMessagesServiceId);

            try {
                baseStore.setIsLoading(true);

                await driverMessagesService.sendMessage(message);
            } finally {
                baseStore.setIsLoading(false);
            }
        }
    }
});
